const locale = require('./detailedHistory.i18n.json');

/*@ngInject*/
const detailedHistoryModalController = function ($rootScope, $scope, $controller, $timeout, $window, coreMediator, submission, submissionConstant, submissionGridConstant, submissionMediator, coreConstant, landingConstant, detailedHistoryGridColumnModel, detailedHistoryRepository) {

    var searchFieldsFilters = [
        {name: 'By User', value: 1},
        {name: 'By Type', value: 4},
        {name: 'By Message', value: 2}
    ];

    var columnPreference = 'view.detailedHistoryColumnsForUnderwriter';
    detailedHistoryGridColumnModel.setColumnPreference(columnPreference);

    $scope.i18n = locale;

    $scope.viewModel = {
        controller: this,
        submission: submission,
        searchFieldsFilters: searchFieldsFilters,
        selectedFieldFilter: searchFieldsFilters[0],
        timeRangeCriterionTemplate: {
            'type': 1, 'name': 'Date Range', 'description': null, 'required': false,
            'dataSetName': 'Date Range', 'isDynamicDataSet': false,
            'variableName': 'tmeRange', 'uiType': 8, 'defaultShow': false,
            'allowedRolesConcat': ''
        },
        dropdownColumns: null,
        gridModel: detailedHistoryGridColumnModel,
        searchDelayInMilliSeconds: submissionConstant.searchDelay,
        requestParams: {
            submissionId: submission.id,
            searchString: '',
            filterFields: 1,
            startIndex: 0,
            numberOfRows: 20,
            key: 'timeCreated',
            sortType: 'desc'
        }
    };

    this.setStartIndex = function (startIndex) {
        $scope.viewModel.requestParams.startIndex = startIndex;
    };

    this.loadRecords = function (onSuccess, onError) {
        submissionMediator.getDetailedHistory($scope.viewModel.requestParams).then(onSuccess, onError);
        $scope.viewModel.dropdownColumns = detailedHistoryGridColumnModel.getDropdownColumns();
    };

    this.resetGridHeaders = function (requestParams) {
        $scope.viewModel.requestParams.key = requestParams.key;
        $scope.viewModel.requestParams.sortType = requestParams.sortType;
        $scope.onFilterChange();
    };

    $scope.onFilterChange = function () {
        $scope.$broadcast(submissionConstant.event.HISTORY_FILTER_CHANGE);
    };

    $scope.onClearSearch = function () {
        $scope.viewModel.requestParams.searchString = '';
        $scope.onFilterChange();
    };

    $scope.onFieldFilterChange = function (filter) {
        $scope.viewModel.selectedFieldFilter = filter;
        $scope.viewModel.requestParams.filterFields = filter.value;
        $scope.onFilterChange();
    };

    $scope.onDownloadUrlClick = function(downloadType) {
        if (downloadType === 'csv') {
            detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'csv').then((url) => {
                $window.open(url, '_blank');
            });
        } else if (downloadType === 'xls') {
            detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'xls').then((url) => {
                $window.open(url, '_blank');
            });
        }
    }

    $scope.$on(coreConstant.event.FILTER_UPDATED, function (event) {
        $scope.viewModel.requestParams.timeRange = $scope.viewModel.timeRangeCriterionTemplate.value;
        $scope.onFilterChange();
    });

    $scope.onColumnCheckboxClick = function (event, column) {
        var isRowClick = event.target.tagName !== 'INPUT',
            value;

        if (!column.disabled) {
            if (isRowClick) {
                column.visible = !column.visible;
            }

            value = detailedHistoryGridColumnModel.getGridColumnXML(column);
            coreMediator.updateUserPreferences(columnPreference, value).then(function () {
                $scope.$broadcast(submissionGridConstant.event.RESET_GRID_COLUMNS);
            });
        }

        event.preventDefault();
        event.stopPropagation();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('detailedHistoryModalController', detailedHistoryModalController);
